export default __webpack_public_path__ + "static/media/ENERGIA.c48649fb.png";